module.exports = __webpack_public_path__ + "static/media/icon-agent-log.4dfdfd59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/icon-agent-log.svg
// module id = 1862
// module chunks = 0